import { createApp } from 'vue'
import App from './App.vue'
import store from './store';
import router from './router'
import { initializeTelemetry } from './telemetry'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

import '@fortawesome/fontawesome-free/css/all.css'
import './scss/theme.scss'
import 'bootstrap/dist/js/bootstrap.bundle'

// Initialize OpenTelemetry
initializeTelemetry()

const app = createApp(App)
app.use(router)
app.use(store)

// Configure toast notifications
app.use(Toast, {
    position: 'top-right',
    timeout: 4000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: 'button',
    icon: true,
    rtl: false,
    transition: 'Vue-Toastification__bounce',
    maxToasts: 5,
    newestOnTop: true
})

// Fetch current user if token exists
store.dispatch('auth/fetchCurrentUser')

app.mount('#app')